import { useState, useEffect } from 'react';

import { os } from '../utils/browser';
import gameImage from '../bg-game.png';
import instruction1 from '../assets/images/t1.png';
import instruction2 from '../assets/images/t2.png';

const AndroidInstallInstructions = ({ onClick }) => (
  <div className="instruction-wrapper">
    <div className="pop-android">
      <div className="toptext">
        <span>Add to home page</span>
      </div>
      <div className="pop2-android">
        <div className="instruction-text-android">To start playing, you need to add this website to home screen</div>
      </div>
      <div className="install-btn-wrapper">
        <button onClick={onClick} className="install-button">
          <span>Install</span>
        </button>
      </div>
    </div>
  </div>
);

const IosInstallInstructions = () => (
  <div className="instruction-wrapper">
    <div className="pop">
      <div className="toptext">
        <span>Add to home page</span>
      </div>
      <div className="pop2">
        <div className="instruction-text">To start playing, you need to add this website to home screen</div>
        <div className="instruction-step-wrapper">
          <div className="step-wrapper">
            <div className="d-flex gap-2 justify-content-round">
              <div className="d-flex flex-column justify-content-between align-items-center flex-fill">
                <span className="sub-title">
                  Step <p className="d-inline step">1</p>
                </span>
                <img src={instruction1} className="step-image" alt="" />
              </div>
              <div className="d-flex gap-3 flex-column justify-content-round align-items-center flex-fill">
                <span className="sub-title">
                  Step <p className="d-inline step">2</p>
                </span>
                <img src={instruction2} className="step-image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const InstallGuide = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const handleAddToHomeScreen = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        setDeferredPrompt(null);
      });
    } else {
      setErrorMessage('App already installed.');
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="Game-container" style={{ position: 'relative' }}>
          {errorMessage && (
            <div className="login-error-message">
              <span>⛔ Error! ⛔</span>
              <br />
              <span>{errorMessage}</span>
            </div>
          )}
          <img src={gameImage} alt="game" className="Game-image" />
          {os === 'Android' ? (
            <AndroidInstallInstructions onClick={handleAddToHomeScreen} />
          ) : (
            <IosInstallInstructions />
          )}
        </div>
      </header>
    </div>
  );
};

export default InstallGuide;
